import React from 'react';
import { Stack, Typography, Tooltip } from '@mui/material';
import Forward from '@mui/icons-material/Forward';

const CompareNumber = ({ mainNumber, compareNumber, tooltipText }) => {
  if (isNaN(mainNumber) || isNaN(compareNumber) || Number(mainNumber) === Number(compareNumber)) {
    return null;
  }

  const isPositive = mainNumber > compareNumber;

  return (
    <Tooltip title={tooltipText}>
      <Stack direction="row" sx={{ alignItems: 'center', gap: 0.5 }}>
        <Forward
          color={isPositive ? 'success' : 'error'}
          fontSize="small"
          sx={{
            transform: isPositive ? 'rotate(-90deg)' : 'rotate(90deg)',
          }}
        />
        <Typography variant="caption" sx={{ color: isPositive ? 'success.main' : 'error.main' }}>
          {parseFloat(Math.abs(mainNumber - compareNumber).toFixed(2))}
        </Typography>
      </Stack>
    </Tooltip>
  );
};

export default CompareNumber;
